import React, { memo } from 'react';
import dynamic from 'next/dynamic';
import {
  BANNER_CONFIG,
  BannerOverrides,
  BannerPlacement
} from '../../utils/constants/banners';

const Banner = dynamic(() => import('./index'), { ssr: false });
const AdManagerBanner = dynamic(() => import('./AdManagerBanner'), {
  ssr: false
});

interface BannerSlotProps {
  placement: BannerPlacement;
  target?: Record<string, unknown>;
  shouldNotRunOnRouter?: boolean;
  overrides?: BannerOverrides;
}

export const BannerSlot: React.FC<BannerSlotProps> = memo(
  ({ placement, target, shouldNotRunOnRouter, overrides }) => {
    const config = BANNER_CONFIG[placement];

    if (!config) return null;

    const lotriverConfig = config.lotriver
      ? { ...config.lotriver, ...overrides?.lotriver }
      : null;

    return (
      <>
        {config.domId && <div id={config.domId} />}

        {lotriverConfig?.containerId && (
          <Banner
            containerId={lotriverConfig.containerId}
            containerClassName={lotriverConfig.containerClassName}
            sid={lotriverConfig.sid}
            bn={lotriverConfig.bn}
            arCn={lotriverConfig.arCn}
            target={target}
            shouldNotRunOnRouter={shouldNotRunOnRouter}
          />
        )}

        {config.adManager && (
          <AdManagerBanner
            bannerName={config.adManager.bannerName}
            tagName={config.adManager.tagName}
          />
        )}
      </>
    );
  }
);

BannerSlot.displayName = `BannerSlot`;
